import React from 'react';
import { Col } from '../../../lib/utils';
import SvgIcon from '../../../components/SvgIcon';

type Props = {
    /** 아이콘 크기 */
    iconSize?: number;
    /** 아이콘 색상 */
    iconFill?: string;
    /** 아이콘 클래스 */
    iconClassName?: string;

    // 원크기
    width?: number;
    height?: number;

    /** 아이콘 크기 */
    mr?: number;
};

const FeedCenterStatisticsGoodPercent = ({
    iconSize = 30,
    iconFill = '#427BE8',
    iconClassName = '',
    width = 64,
    height = 64,
    mr = 12,
}: Props) => {
    return (
        <Col
            style={{
                width: `${width}px`,
                height: `${height}px`,
            }}
            className={`justify-center items-center border-[0.25px] border-solid border-[#FFB93640] rounded-[50px] bg-[#FFF0AE] mr-[${mr}px] pb-[2px]`}
        >
            <SvgIcon name="SvgCenterStatisticsGoodPercent" size={iconSize} fill={iconFill} className={iconClassName} />
        </Col>
    );
};

export default FeedCenterStatisticsGoodPercent;
